<div [class]="'esn-search-field esn-search-field--' + size()" [class.esn-search-field--disabled]="isDisabled()">
  @if (size() === 'compact') {
    <esn-icon class="esn-search-field__icon" name="search" [size]="20" />
  }
  <input
    class="esn-search-field__control"
    type="search"
    enterkeyhint="search"
    [value]="value()"
    [placeholder]="placeholder()"
    [disabled]="isDisabled()"
    [attr.aria-label]="accessibleName()"
    (input)="handleInput($event)"
    (keydown.enter)="handleEnter()"
    (blur)="handleBlur()"
  />
  @if (size() === 'default') {
    <esn-icon class="esn-search-field__icon" name="search" [size]="20" />
  }
</div>
